import React, { useEffect } from 'react';
import ErrorScreenTypeEnum from '../../types/enums/errorScreenTypeEnum';
import LoadingError from '../../components/error/LoadingError';
import GenericError from '../../components/error/GenericError';
import ProviderUnavailableError from '../../components/error/ProviderUnavailableError';
import DataSharingCancelled from '../../components/error/DataSharingCancelled';
import ReAuthenticateCancelled from '../../components/error/ReAuthenticateCancelled';
import ReconfirmationError from '../../components/error/ReconfirmationError';
import RevocationError from '../../components/error/RevocationError';
import { useAppState, useErrorState, useStepsState } from '../../hooks/zustandHooks';
import { consentStorage } from '../../domain/services';
import { useHistory } from 'react-router';
import { usePaymentAccountConfirmationSummary, useSettings } from '../../hooks/queryHooks';
import PaymentAccoutConfirmationError from '../../components/error/PaymentAccoutConfirmationError';
import { completeConnection } from '../../hooks/utils';
import Container from '../../components/container/Container';

const ErrorContainer = () => {
  const error = useErrorState(state => state.error);
  const history = useHistory();
  const { settings } = useSettings();
  const { paymentAccountConfirmationSummary } = usePaymentAccountConfirmationSummary();
  const redirectUrl = useAppState(state => state.appState.redirectUrl);
  const setFlow = useStepsState(state => state.setFlow);

  const consentEnd = consentStorage.getConsentEnd();
  const oldConsentEndDate = consentEnd?.oldConsentEnd ? new Date(consentEnd!.oldConsentEnd) : undefined;

  const onChooseDifferentBank = () => history.push('/bank-select');

  useEffect(() => {
    if (window.hj && error?.code) {
      window.hj('tagRecording', [`Error: ${error.code}`]);
    }
  }, [error?.code]);

  const getErrorComponent = () => {
    switch (error?.type) {
      case ErrorScreenTypeEnum.GenericError:
        return <GenericError code={error.code} chooseDifferentBank={onChooseDifferentBank} />;
      case ErrorScreenTypeEnum.LoadingError:
        return <LoadingError code={error.code} finishConnection={completeConnection} />;
      case ErrorScreenTypeEnum.ProviderUnavailableError:
        return (
          <ProviderUnavailableError
            code={error.code}
            chooseDifferentBank={onChooseDifferentBank}
            finishConnection={completeConnection}
          />
        );
      case ErrorScreenTypeEnum.DataSharingCancelledError:
        if (settings?.enableCreditInformationFlow) {
          setFlow('CreditInformationFlow');
          history.push('/tu-end-success', { dataSharingCancelledError: true });
          return;
        }
        return (
          <DataSharingCancelled chooseDifferentBank={onChooseDifferentBank} finishConnection={completeConnection} />
        );
      case ErrorScreenTypeEnum.ReAuthenticateCancelledError:
        return <ReAuthenticateCancelled finishConnection={completeConnection} oldConsentEndDate={oldConsentEndDate} />;
      case ErrorScreenTypeEnum.ReconfirmationError:
        return (
          <ReconfirmationError code={error.code} redirectUrl={redirectUrl} finishConnection={completeConnection} />
        );
      case ErrorScreenTypeEnum.RevocationError:
        return <RevocationError code={error.code} redirectUrl={redirectUrl} finishConnection={completeConnection} />;
      case ErrorScreenTypeEnum.PaymentAccountConfirmationCancelledError:
        return (
          <PaymentAccoutConfirmationError
            finishConnection={completeConnection}
            errorType={error.type}
            customerName={paymentAccountConfirmationSummary?.customerName || ''}
          />
        );
      case ErrorScreenTypeEnum.PaymentAccountConfirmationError:
        return (
          <PaymentAccoutConfirmationError
            finishConnection={completeConnection}
            errorType={error.type}
            customerName={paymentAccountConfirmationSummary?.customerName || ''}
          />
        );
      default:
        return <GenericError code={error?.code} chooseDifferentBank={onChooseDifferentBank} />;
    }
  };

  return (
    <Container>
      <div className="flex justify-center items-center">{getErrorComponent()}</div>
    </Container>
  );
};

export { ErrorContainer };
export default ErrorContainer;
